// extracted by mini-css-extract-plugin
export default {"software":"cH_ff6QOn"};